// Collaborator-free path, request body, and reads for POST /api/login.
// authenticate() posts loginRequestBody through loginApi.
// handleAuthResponse branches on readLoginDispatch and still stashes the original object.
// handleSuccessfulAuth and redirectUserToTaxesApp use readLoginSuccess.
// ChooseUsername reads suggestedUsername through suggestedUsernameFromStash.
// Each published field is read when the caller reads it, matching the inline access.
// Alert and AllAcceptedCredentialsOptions are the same references.
// methods and phoneNumbers are the same arrays.
// A null body throws on the first property access. Unknown keys are ignored.

export const loginApi = process.env.VUE_APP_AUTH_API

export function loginRequestBody(fields) {
	return {
		username: fields.username,
		password: fields.password,
		captcha: fields.captcha,
		fingerprint: fields.fingerprint,
		appYear: fields.appYear,
		appName: fields.appName,
		redirect_uri: fields.redirect_uri,
		client_id: fields.client_id,
		state: fields.state,
		platform: fields.platform,
		isFreeFile: fields.isFreeFile,
	}
}

export function readLoginSuccess(data) {
	return {
		get authenticated() {
			return data.authenticated
		},
		get redirectUrl() {
			return data.redirectUrl
		},
		get action() {
			return data.action
		},
		get suggestedUsername() {
			return data.suggestedUsername
		},
		get AllAcceptedCredentialsOptions() {
			return data.AllAcceptedCredentialsOptions
		},
	}
}

// Challenge token, methodId, and emails stay on the original object.
// The failure alert is the same reference handleAuthResponse passes on.
export function readLoginDispatch(data) {
	return {
		get authenticated() {
			return data.authenticated
		},
		get verificationCode() {
			return data.verificationCode
		},
		get reason() {
			return data.reason
		},
		get methods() {
			return data.methods
		},
		get phoneNumbers() {
			return data.phoneNumbers
		},
		get defaultMethod() {
			return data.defaultMethod
		},
		get sentNumber() {
			return data.sentNumber
		},
		get alert() {
			return data.alert
		},
	}
}

// Same value as loginData?.suggestedUsername, including a function-valued stash.
// Null and undefined short-circuit. Any other value reads suggestedUsername only.
export function suggestedUsernameFromStash(loginData) {
	if (loginData == null) {
		return undefined
	}
	return readLoginSuccess(loginData).suggestedUsername
}
